import React, { useEffect, useState } from "react";
import ReduxModal from "components/react-lib/generic-ui/modals/ReduxModal";
import { MODALS } from "modals";
import FindUserForm from "components/users/FindUserForm";
import UserCard from "components/users/UserCard";
import ToggleFriendIconButton from "components/talk/ToggleFriendIconButton";
import { useSelector } from "react-redux";
import EnableNotificationsButton from "components/notifications/EnableNotificationsButton";

export default function ManageFriendsModal() {

  const modalState = useSelector((state) => state.modals[MODALS.manageFriendsModal])
  const [user, setUser] = useState();

  useEffect(() => {
    setUser();
  }, [modalState]);

  return (
    <ReduxModal
      name={MODALS.manageFriendsModal}
      title="Manage Friends"
      fullWidth
      maxWidth="sm"
    >
      <EnableNotificationsButton />
      <FindUserForm onSearchCompleted={setUser} py={2} />
      <UserCard user={user} action={<ToggleFriendIconButton user={user} />} />
    </ReduxModal>
  );

}
